module.exports = __webpack_public_path__ + "static/media/组 4460@2x.952948e1.png";